<template>
    <div class="papsi-wrapper flex justify-between">
        <div>
            <h1 class="text-2xl font-semibold text-[#24723b]">Employee Leave Record</h1>
            <p class="text-xs text-[#747474] mt-2">Home / Employee Page /  Personnel Services / Leave Credit</p>
        </div>
        <div>
            <button  class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3" @click="addLeaveRecordModal = true, type = 'Add'" >+ ADD LEAVE RECORD</button>
        </div>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="mt-6">
            <div class="grid grid-cols-11 w-full gap-3 mb-5">
                <input type="text"  @input="isTyping = true" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
                <select class="col-span-1 border-[#b7b8b7] border  rounded-md   outline-none  text-[#535353] text-center text-sm" v-model="sort" @change="leaveFilter" >
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                    <option value="2022">2021</option>
                    <option value="2021">2020</option>
                    <option value="ALL">ALL</option>
                </select>
            </div>
            <div class="bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl  :Action="true"  @EditButton="EditLeaveRecord" @ViewButton="Viewbutton" :column="column"  :header="header" :info="info" VButton="true" :DButton="false" :EButton="true" />
            </div>
        </div>
    </div>
    <div v-if="leaveRecordModal">
        <LeaveRecord @close="leaveRecordModal = false" :Information="Information" @addLeaveRecord="AddLeaveRecord = true, EditData = null, editAdd = false" ref="refresh" @deleteLeaveRecord="deleteLeaveRecord" @editLeaveRecord="modifyLeaveRecord"/>
        <div v-if="AddLeaveRecord">
            <AddLeaveRecord @cancel="AddLeaveRecord = false" @addLeaveRecord="insertLeaveRecord" :data="EditData" @editLeaveRecord="editSpecificLeave" :edit="editAdd" />
        </div>
    </div>
    <div v-if="addLeaveRecordModal">
        <div @click="closeLeaveRecord" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-green-800 py-3 px-6">
                    <p class="text-[#ffffff] text-md font-bold">LEAVE RECORD</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Employee</p>
                    <select class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="employee_id">
                        <option value="" selected disabled>Select Employee</option>
                        <option v-for="(info,index) in GetName" :key="index" :value="info.employee_key">{{ info.full_name }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Calendar year</p>
                    <select class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="calendaryearvalue" >
                        <option value="" selected disabled>Select Calendar Year</option>
                        <option v-for="(info,index) in calenderyear" :key="index" :value="info">{{ info }}</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Leave Credit(days)</p>
                    <input type="number" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" placeholder="00" min="0" max="99" size="1" maxlength="2" v-model="creditDaysValue">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Leave Credit(hh:mm)</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="creditTimeValue" @input="formatTime">
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md"     v-if="type === 'Edit'" v-on:click="editLeaveRecord">Update</button>
                <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md"     v-if="type === 'Add'" v-on:click="addLeaveRecord">Create</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" v-on:click="closeLeaveRecord">Cancel</button>
            </div>
        </div>
        </div>
    </div>
    <div v-if="Validation">
        <Prompt @CloseSignatory="Validation = false" type="VALIDATION"/>
    </div>

    <div v-if="addlr">
        <Prompt @CloseSignatory="addlr = false" type="ADDLVRC"/>
    </div>

    <div v-if="lrExists">
        <Prompt @CloseSignatory="lrExists = false" type="LVEXS"/>
    </div>
    <div v-if="lrUpdated">
        <Prompt @CloseSignatory="lrUpdated = false" type="LVUPDATE"/>
    </div>

    
   
</template>

<script>
import _ from 'lodash';
import { defineComponent } from 'vue';
import TableControl from '../../controls/TableControl/TableControl.vue'
import Services from '../../../services/admin.js'
import LeaveRecord from '../modal/LeaveRecordModal.vue'
import AddLeaveRecord from '../modal/AddLeaveRecordModal.vue'
import Prompt from '../../controls/Prompt/RequestPromt.vue'

export default defineComponent({
    components:{
        TableControl,
        LeaveRecord,
        AddLeaveRecord,
        Prompt
    },
    data(){
        return{
            editAdd:           false,
            EditData:           null,
            sort:              'ALL',
            isTyping:          false,
            search:               '',
            lrUpdated:         false,
            lrExists:          false,
            addlr:             false,
            leaveRecordKey:       '',
            type:               null,
            Validation:         false,
            info:               '',
            leaveRecordModal:   false,
            Information:        null,
            AddLeaveRecord:     false,
            header:[
            {
                id: 1,
                label: 'NoofItems',
                title: 'No',
                visible: true
            },
            {
                id: 2,
                label: 'Employee ID',
                title: 'Employee ID',
                visible: true
            },
            {
                id: 3,
                label: 'Employee',
                title: 'Employee',
                visible: true
            },
            {
                id: 4,
                label: 'Calendar Year',
                title: 'Calendar Year',
                visible: true
            },
            {
                id: 5,
                label: 'Leave Credit',
                title: 'Leave Credit',
                visible: true
            },
            {
                id: 6,
                label: 'Action',
                title: 'Action',
                visible: true
            }
            ],
            column:[
                'index',
                'employee_key',
                'employee_name',
                'calender_year',
                'leave_credit',
            ],
            calenderyear:[
                '2024',
                '2023',
                '2022',
                '2021',
            ],
            addLeaveRecordModal:false,
            employee_id:'',
            calendaryearvalue:'',
            creditDaysValue:'',
            creditTimeValue:'00:00',
            searchInfo:'',
            }
        },
        watch: {
                search: _.debounce(function() {
                this.isTyping = false;
                }, 600),
                isTyping: function(value) {
                if (!value) {
                    this.searchleave()
                }
                }
        },
        mounted(){
            this.getleavecredit();
            this.getEmployeeName()
        },
        methods: {
            leaveFilter(){
                if(this.sort == 'ALL' ){
                    this.info = this.searchInfo
                    return
                }
                this.info = this.searchInfo.filter(calendar=>calendar.calender_year == this.sort)
            },
            async getEmployeeName(){
                this.$emit("showLoader")
                const success    =  await Services.getEmployeeName()
                this.GetName     =  success.data
                this.$emit("hideLoader")
            },
          
            test(){
                this.modal    = false  
            },
            outsidemodal(){
                this.modal    = false  
            },
            async getleavecredit(){
                const success       = await Services.getAllLeaveCredit(this.search);
                this.searchInfo     = success.data
                this.info           = success.data
            },
            async searchleave(){
                const success = await Services.getAllLeaveCredit(this.search);
                this.searchInfo     = success.data
                this.info     = success.data
                this.leaveFilter()
            },
            Viewbutton(data){
   
                this.Information      = data
                this.leaveRecordModal = true
            },
            async addLeaveRecord(){
                if( this.employee_id === '' || this.calendaryearvalue  === '' || this.creditDaysValue === ''){
                   this.Validation = true
                }
                else{
                    const success = await Services.addLeaveRecord(this.employee_id,this.calendaryearvalue,this.creditDaysValue,this.creditTimeValue);
                    let added = success.success
                    if(added === true){
                        this.addLeaveRecordModal = false
                        this.addlr = true
                        this.getleavecredit();
                    }
                    else{
                        this.lrExists = true
                    }  
                }
            },
            formatTime() {
                
                var sanitized = this.creditTimeValue.replace(/[^0-8]/g, "");

                // Ensure that hours are between 00 and 08
                var hours = sanitized.slice(0, 2).padStart(2, "0");

                // Ensure that minutes are between 00 and 59
                var minutes = sanitized.slice(2, 4).padStart(2, "0");

                // Check if the time exceeds the limit of 08:00
                if (parseInt(hours) > 8 || (parseInt(hours) === 8 && parseInt(minutes) > 59)) {
                    hours = "08";
                    minutes = "00";
                }

                // Update the input value
                this.creditTimeValue = hours + ":" + minutes;
            },
            closeLeaveRecord(){
                this.employee_id         = '',
                this.calendaryearvalue   = '',
                this.creditDaysValue     = '',
                this.creditTimeValue     = '00:00',
                this.addLeaveRecordModal = false
            },
            async insertLeaveRecord(fromdate,todate,particular,days,undertime,late,remarks){
                this.$emit("showLoader")
                if(!fromdate || !todate || !particular || !days || !remarks){
                    this.Validation = true
                    this.$emit("hideLoader")
                    return
                }

                if(undertime == "00:00"){
                    undertime = null
                }
                if(late == "00:00"){
                    late = null
                }
                const success = await Services.addLeave(fromdate,todate,particular,days,undertime,late,remarks,this.Information.leaverecord_no);
                let added = success.success
                if(added === true){
                    this.AddLeaveRecord = false
                }
                    this.testewwqe()
                    this.$emit("hideLoader")
            },
            testewwqe(){
                this.$refs.refresh.getLeaveRecord()
            },
            EditLeaveRecord(data){
                this.type = 'Edit'
                this.addLeaveRecordModal = true
                this.leaveRecordKey      = data.leaverecord_no
                this.employee_id         = data.employee_key
                this.calendaryearvalue   = data.calender_year
                this.creditDaysValue     = data.leave_credit
                this.creditTimeValue     = data.leave_credit_time
                // alert(data.leaverecord_no)editLeaveRecord
            },
            async editLeaveRecord(){
                this.$emit('showLoader')
                await Services.editLeaveRecord(this.leaveRecordKey,this.employee_id,this.calendaryearvalue,this.creditDaysValue,this.creditTimeValue);
                this.addLeaveRecordModal = false
                this.getleavecredit();
                this.lrUpdated = true
                this.$emit('hideLoader')

            },
            async deleteLeaveRecord(id){
                this.$emit('showLoader')
                await Services.deleteLeaveRecord(id);
                this.testewwqe()
                this.$emit('hideLoader')
                
            },
            async modifyLeaveRecord(id,fromdate,todate,particular,days,undertime,late,remarks){
                this.$emit('showLoader')
                this.editAdd = true
                this.AddLeaveRecord = true
                // const success = await Services.addLeave(id,fromdate,todate,particular,days,undertime,late,remarks);
                // let added = success.success
                this.EditData = [
                    {
                       id: id,
                       fromdate:fromdate,
                       todate:todate,
                       particular:particular,
                       days:days,
                       undertime:undertime,
                       late:late,
                       remarks:remarks, 
                    }]
                // await Services.deleteLeaveRecord(id);
                // this.testewwqe()
                this.$emit('hideLoader')
                
            },
            async editSpecificLeave(id,fromdate,todate,particular,days,undertime,late,remarks){
                this.$emit('showLoader')
          
             const success = await Services.editLeave(id,fromdate,todate,particular,days,undertime,late,remarks);

             if(success.success == true){
                this.AddLeaveRecord = false
                this.testewwqe()
             }
             this.$emit('hideLoader')
            
            }
        },
})
</script>



<style>
input[type=time]::-webkit-datetime-edit-ampm-field { display: none; }
</style>

